import { baseApi } from "../api/baseApi.ts";
import type {
    DashboardStatsResponse,
    ThreatSummaryResponse,
    ThreatDataResponse
} from "../api/types.ts";

export const dashboardApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // Get dashboard statistics
        getDashboardStats: builder.query<DashboardStatsResponse, void>({
            query: () => ({
                url: '/dashboard/stats/',
                method: 'GET',
            }),
            providesTags: ['DashboardStats'],
        }),

        // Get threat summary by severity with trends
        getThreatSummary: builder.query<ThreatSummaryResponse, void>({
            query: () => ({
                url: '/dashboard/threat-summary/',
                method: 'GET',
            }),
            providesTags: ['ThreatSummary'],
        }),

        // Get comprehensive threat data breakdown
        getThreatData: builder.query<ThreatDataResponse, void>({
            query: () => ({
                url: '/dashboard/threat-data/',
                method: 'GET',
            }),
            providesTags: ['ThreatData'],
        }),

        // --- NEW: Get Global Stats for the Home Dashboard ---
        getGlobalStats: builder.query<any, { window?: string }>({
            query: (params) => ({
                url: '/dashboard/global-stats/',
                method: 'GET',
                params,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetDashboardStatsQuery,
    useGetThreatSummaryQuery,
    useGetThreatDataQuery,
    useGetGlobalStatsQuery, // <-- Export the new hook!
} = dashboardApi;